export * from "./hotel-bts-coverage";
